export const matchFacilityId = (entry, facilityId) => {
    return facilityId === entry.facilityId || facilityId === entry.databaseId;
};
export const getFacilityId = (entry) => {
    return entry.facilityId ?? entry.databaseId ?? 0;
};
